import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { getFirstAccessibleHomePath } from '@/utils/home-path'

/** Public routes (login) — redirect authenticated users to a page they can open. */
export function PublicRoute() {
  const { isAuthenticated, isHydrated, user } = useAuth()

  if (!isHydrated) return null

  if (isAuthenticated) {
    if (!user) return null
    return <Navigate to={getFirstAccessibleHomePath(user)} replace />
  }

  return <Outlet />
}
